import React, { FC } from 'react';
import Loader from 'react-loader-spinner';

import Styled from './style';
import useHook from './hook';
import AppButton from '../../shared/app-button';
import members from '../../assets/images/members.png';
import { AuthWrapper } from '../../shared/auth-wrapper';
import { Typography } from '../../shared/typography';
import colors from '../../assets/colors';

type IProps = {};
const loaderSize = 50;

const JoinPage: FC<IProps> = () => {
	const { isLoaded, isLoading, team, joinTeam } = useHook();

	return (
		<AuthWrapper>
			<Styled.Bottom>
				{!isLoaded ? (
					<Loader
						type="TailSpin"
						color={colors.blue}
						height={loaderSize}
						width={loaderSize}
					/>
				) : (
					<Styled.Content>
						<div style={{ width: '100%' }}>
							<Styled.Center>
								<Styled.Ellipse>
									<img
										src={members}
										style={{ width: 80, marginTop: 2 }}
										alt=""
									/>
								</Styled.Ellipse>
								<Typography style={{ textAlign: 'center' }} size="large">
									{team.name}
								</Typography>
							</Styled.Center>
							<AppButton
								style={{ maxWidth: 475 }}
								title="Join"
								color="lightGrey"
								titleColor="black"
								borderWidth={1}
								loaderColor="blue"
								type="bold"
								isBorder
								callBack={joinTeam}
								isLoading={isLoading}
							/>
						</div>
					</Styled.Content>
				)}
			</Styled.Bottom>
		</AuthWrapper>
	);
};

export default JoinPage;
